"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var react_socks_1 = __importDefault(require("react-socks"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Block_1 = __importDefault(require("./styledComponents/Block"));

var Row_1 = __importDefault(require("./styledComponents/Row"));

var SummaryBlocks_meta_1 = require("./SummaryBlocks.meta");

var factHasValue_1 = require("../../../shared/factHasValue");

var SummaryBlocks =
/** @class */
function (_super) {
  __extends(SummaryBlocks, _super);

  function SummaryBlocks(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = SummaryBlocks_meta_1.SUMMARY_BLOCKS_CATEGORY_KEY;
    _this.componentKey = SummaryBlocks_meta_1.SUMMARY_BLOCKS_COMPONENT_KEY;

    _this.getRows = function (props) {
      var _a = props.itemsPerRow,
          itemsPerRow = _a === void 0 ? 3 : _a,
          lineBreaks = props.lineBreaks;

      var isLineBreak = function isLineBreak(block) {
        if (!lineBreaks || lineBreaks.keys.length <= 0) {
          return false;
        }

        var field = lineBreaks.field,
            keys = lineBreaks.keys;
        var value = block[field];
        return keys.filter(function (key) {
          return key.toLowerCase() === value.toLowerCase();
        }).length > 0;
      };

      var blocks = _this.getOrderedBlocks(props);

      return ksys_app_template_1.utils.collection.split(blocks, itemsPerRow, isLineBreak);
    };

    _this.getBlocks = function (row, props) {
      var _a = props.placeholder,
          placeholder = _a === void 0 ? '-' : _a,
          _b = props.itemsPerRow,
          itemsPerRow = _b === void 0 ? 3 : _b,
          onDocumentClick = props.onDocumentClick,
          accessibilityGroupText = props.accessibilityGroupText,
          includeTitleInAccessibilityGroup = props.includeTitleInAccessibilityGroup;
      return row.map(function (block, index) {
        var value = block.value,
            blockProps = __rest(block, ["value"]);

        if (!blockProps.onDocumentClick && onDocumentClick) {
          blockProps.onDocumentClick = onDocumentClick;
        } // Exit out if no value and show blank is set to true


        if (!factHasValue_1.factHasValue(block)) {
          var blankDataOptions = block.blankDataOptions;

          if (blankDataOptions && !blankDataOptions.showBlank) {
            return;
          }
        } // Only set if it has not been configured


        if (accessibilityGroupText && !blockProps.factAccessibilityGroupText) {
          blockProps.factAccessibilityGroupText = accessibilityGroupText;
        } // due to the boolean type, we need to check if undefined to be able to push false on the block props


        if (includeTitleInAccessibilityGroup !== undefined && blockProps.includeTitleInAccessibilityGroup === undefined) {
          blockProps.includeTitleInAccessibilityGroup = includeTitleInAccessibilityGroup;
        }

        return react_1.default.createElement(Block_1.default, __assign({
          key: "block_" + index,
          value: ksys_app_template_1.utils.typeChecks.isNullOrUndefined(value) ? placeholder : value,
          basis: 100 / itemsPerRow + "%"
        }, blockProps));
      });
    };

    return _this;
  }

  SummaryBlocks.prototype.getOrderedBlocks = function (props) {
    var _a = props.blocks,
        blocks = _a === void 0 ? [] : _a,
        _b = props.order,
        order = _b === void 0 ? [] : _b;

    var workingCollection = __spreadArrays(blocks);

    var response = [];

    for (var _i = 0, order_1 = order; _i < order_1.length; _i++) {
      var key = order_1[_i];

      for (var i = 0; i < workingCollection.length; i++) {
        var block = workingCollection[i];

        if (block.key === key) {
          response.push(block);
          workingCollection.splice(i, 1);
          i--;
        }
      }
    }

    response.push.apply(response, workingCollection);
    return response;
  };

  SummaryBlocks.prototype.render = function () {
    var _this = this;

    var breakpoints = this.breakpoints;
    return react_1.default.createElement(react_1.Fragment, null, breakpoints.map(function (breakpoint, breakpointIndex) {
      var props = breakpoint.props;

      if (props) {
        var breakpointProps = _this.getBreakpointComponentProps(breakpoint, breakpointIndex);

        var rows = _this.getRows(props);

        var className = props.className;
        return react_1.default.createElement(react_socks_1.default, __assign({}, breakpointProps), react_1.default.createElement(Wrapper_1.default, {
          className: className
        }, (rows || []).map(function (row, index) {
          return react_1.default.createElement(Row_1.default, {
            key: "row_" + index
          }, _this.getBlocks(row, props));
        })));
      }
    }));
  };

  SummaryBlocks = __decorate([mobx_react_1.observer], SummaryBlocks);
  return SummaryBlocks;
}(shared_1.ResponsiveComponentBase);

exports.SummaryBlocks = SummaryBlocks;
exports.default = shared_1.InjectedStyledComponent(SummaryBlocks, SummaryBlocks_meta_1.SUMMARY_BLOCKS_CATEGORY_KEY, SummaryBlocks_meta_1.SUMMARY_BLOCKS_COMPONENT_KEY);